module.exports = __webpack_public_path__ + "img/save-o.c3f43752.png";